<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <h2 style="margin-top: 30px; margin-bottom: -10px;">Invoice Report <span>for {{ companyClient }}</span></h2>
          <h4 style="margin-top: 30px; margin-bottom: 50px;">Sender: <span>{{ senderCompanyName }}</span></h4>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <b-dropdown v-model="currentFilter" toggle-class="btn-primary" style="margin-top: -35px;">
            <template v-slot:button-content>
              Filter: {{ currentFilter | capitalize }}
            </template>
            <b-dropdown-item @click="filterInvoices('all')">All</b-dropdown-item>
            <b-dropdown-item @click="filterInvoices('sent')">Sent</b-dropdown-item>
            <b-dropdown-item @click="filterInvoices('paid')">Paid</b-dropdown-item>
          </b-dropdown>
          <div style="width: 230%; height: 100px;">
            <div style="position: relative;">
              <div style="position: absolute; top: -27px; right: 0; font-weight: bold;">
                Total: € {{ totalAmount }}
              </div>
              <table class="table table-striped invoices wider-table" style="height: 100px;">
                <tbody>
                <tr v-for="invoice in invoices" :key="invoice.id">
                  <td style="vertical-align: middle;">{{ invoice.invoice_date | formatDate }}</td>
                  <td style="vertical-align: middle;">{{ invoice.number }}</td>
                  <td style="vertical-align: middle;" class="customer hidden-xs">{{ invoice.project_reference }}</td>
                  <td :class="'total ' + (invoice.currency !== 'EUR' ? 'warning-currency' : '')" style="vertical-align: middle;text-align: right;">
                    <span>€ {{ invoice.currency_total_amount | formatNumber }}</span>
                    <span class="warning-text" v-if="invoice.currency !== 'EUR'">
                      <font-awesome-icon icon="fa fa-triangle-exclamation" id="tooltip-non-euro" />
                      <b-tooltip target="tooltip-non-euro" triggers="hover">
                        <div class="tooltip-text">
                          {{ $gettext('this amount is not taken into account because is not set in EUR.') }}
                        </div>
                      </b-tooltip>
                    </span>
                  </td>
                  <td class="table-status-label" style="text-align: right; display: flex; align-items: center; justify-content: flex-end;">
                    <a :href="invoice.pdf_file" class="status-badge blue" target="_blank" style="margin-right: -30px; padding: -75px; border-radius: 50%;">
                      <font-awesome-icon icon="fa fa-cloud-arrow-down" :style="{ color: '#4DB9E4', marginTop: currentFilter === 'paid' ? '18px' : '0' && currentFilter === 'sent' ? '18px' : '0' }" />
                    </a>
                    <span v-if="invoice.status === 'p' && currentFilter !== 'paid'"
                          class="label"
                          style="background-color: #CBF9CF; color: black; padding: 3px 20px; border-radius: 70%; ">paid</span>
                    <span v-if="invoice.status === 'p' && currentFilter === 'paid'"
                          class="label"
                          style="background-color: #CBF9CF; color: black; padding: 3px 20px; border-radius: 70%; margin-top: 18px;">paid</span>
                    <span v-if="invoice.status === 's' && currentFilter !== 'sent'"
                          class="label"
                          style="background-color: #C3E4F5; color: black; padding: 3px 20px; border-radius: 70%;  ">sent</span>
                    <span v-if="invoice.status === 's' && currentFilter === 'sent'"
                          class="label"
                          style="background-color: #C3E4F5; color: black; padding: 3px 20px; border-radius: 70%; margin-top: 20px;">sent</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="pagination">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceService from "@/store/services/invoice.service.js";
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
  name: "InvoiceReport",
  mixins: [settingsPageSetup],
  data() {
    return {
      pageSettings: {
        title: this.$gettext("InvoiceReport"),
      },
      senderCompanyName: "",
      companyClient: "",
      invoices: [],
      totalAmount: "",
      currentFilter: "all",
      url: "",
      selectedInvoiceId: null,
    };
  },
  methods: {
    fetchData() {
      let filterParams = {};
      if (this.currentFilter === "sent") {
        filterParams.status = "s";
      } else if (this.currentFilter === "paid") {
        filterParams.status = "p";
      }

      InvoiceService.invoiceReportList(this.$route.params["customeruuid"], {
        page: this.$route.params["pageid"],
        ...filterParams,
      }).then((response) => {
        console.log(this.$route.params);
        console.log(response.data);
        this.senderCompanyName = response.data["sender_company"];
        this.companyClient = response.data["customer"];
        this.invoices = response.data["invoices"];
        this.calculateTotalAmount();
      }).catch((error) => {
        console.error("Error fetching invoice report:", error);
      });
    },
    calculateTotalAmount() {
      const total = this.invoices.reduce(
          (total, invoice) => total + parseFloat(invoice.currency_total_amount),
          0
      );
      this.totalAmount = total.toFixed(2);
    },
    filterInvoices(filter) {
      this.currentFilter = filter;
      this.fetchData();
    },
    openInvoicePdf(url) {
      if (url !== "#") {
        window.open(url, '_blank');
      }
    },
  },
  created() {
    this.fetchData();
  },
  computed: {
    selectedInvoicePdfUrl() {
      const selectedInvoice = this.invoices.find(
          (invoice) => invoice.id === this.selectedInvoiceId
      );
      return selectedInvoice ? selectedInvoice.pdf_url : "#";
    },
  },
  filters: {
    formatDate: function (dateString) {
      const options = { day: "2-digit", month: "short", year: "numeric" };
      return new Date(dateString).toLocaleDateString("en-US", options);
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

};
</script>

